module.exports = __webpack_public_path__ + "img/navigation-pointer-02.bb841852.svg";